export default __webpack_public_path__ + "static/blog-rich-825b817a3211ecc10b21a3cdd2707998.jpg";